var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "section" },
    [
      _vm.isloading
        ? _c("b-loading", { attrs: { "is-full-page": true } })
        : _c(
            "div",
            { staticClass: "container" },
            [
              _c(
                "div",
                { staticClass: "buttons is-right" },
                [
                  _c(
                    "b-button",
                    {
                      attrs: {
                        type: "is-primary",
                        disabled: !_vm.hasShippings,
                      },
                      on: { click: _vm.exportScanShippings },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("global.export")) + " ")]
                  ),
                ],
                1
              ),
              _c("ag-grid-vue", {
                staticClass: "ag-theme-alpine",
                staticStyle: { width: "100%", height: "1000px" },
                attrs: {
                  modules: _vm.modules,
                  pagination: true,
                  "pagination-auto-page-size": true,
                  "grid-options": _vm.gridOptions,
                  "row-data": _vm.shippings,
                  "column-defs": _vm.columnDefs,
                },
                on: {
                  "grid-ready": _vm.onGridReady,
                  "row-clicked": _vm.showBarcodes,
                },
              }),
              _c(
                "b-modal",
                {
                  attrs: {
                    active: _vm.showingBarcodes,
                    scroll: "keep",
                    "has-modal-card": "",
                  },
                  on: {
                    "update:active": function ($event) {
                      _vm.showingBarcodes = $event
                    },
                  },
                },
                [
                  _c("div", { staticClass: "modal-card" }, [
                    _c("header", { staticClass: "modal-card-head" }, [
                      _c("p", { staticClass: "modal-card-title" }, [
                        _vm._v(" " + _vm._s(_vm.selectedShippingTitle) + " "),
                      ]),
                    ]),
                    _c("section", { staticClass: "modal-card-body" }, [
                      _vm.selectedBarcodes.length
                        ? _c(
                            "div",
                            { staticClass: "barcode-list" },
                            _vm._l(_vm.selectedBarcodes, function (barcode) {
                              return _c(
                                "span",
                                {
                                  key: barcode,
                                  staticClass:
                                    "tag is-link is-light barcode-tag",
                                },
                                [_vm._v(" " + _vm._s(barcode) + " ")]
                              )
                            }),
                            0
                          )
                        : _c("p", [_vm._v(" No barcodes ")]),
                    ]),
                    _c("footer", { staticClass: "modal-card-foot" }, [
                      _c(
                        "button",
                        {
                          staticClass: "button is-fullwidth",
                          on: {
                            click: function ($event) {
                              _vm.showingBarcodes = false
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("global.close")) + " ")]
                      ),
                    ]),
                  ]),
                ]
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }